import React from 'react'
import { Label, RadioGroup, XStack, YStack, Text, TextProps } from 'tamagui'
import { HeroIcon } from '@components/HeroIcon'

interface IHeroRadioOption {
  name: string
  value: string
}

interface IHeroRadiosProps extends React.ComponentProps<typeof RadioGroup> {
  options: IHeroRadioOption[]
  size?: number
  label?: string
  labelStyle?: TextProps
  showInvalidFeedback?: boolean
}

export function HeroRadio({
  options,
  size,
  label,
  showInvalidFeedback = false,
  labelStyle,
  ...props
}: IHeroRadiosProps) {
  return (
    <RadioGroup
      name="form"
      aria-labelledby="Selecione um item"
      defaultValue="0"
      {...props}
    >
      {label && (
        <Text
          color="$text-primary"
          fontFamily="$mulishRegular"
          fontSize="$font-size-xxs"
          marginBottom={16}
        >
          {label}
        </Text>
      )}
      <YStack width={300} alignItems="flex-start" gap={20}>
        {options.map((option) => {
          const id = `radio-${option.value}`
          return (
            <XStack alignItems="center" gap={10} key={option.value}>
              <RadioGroup.Item
                id={id}
                testID="hero-radio"
                value={option.value}
                width={size}
                height={size}
                cursor="pointer"
                borderColor={
                  props.value === option.value ? '$accent' : '$control-inactive'
                }
                backgroundColor={
                  props.value === option.value ? '$accent' : '$bg-input'
                }
              >
                <RadioGroup.Indicator
                  backgroundColor="$text-on-accent"
                  width="50%"
                  height="50%"
                />
              </RadioGroup.Item>
              <Label
                htmlFor={id}
                color="$text-primary"
                fontSize="$font-size-xxs"
                fontFamily="$mulishRegular"
                pt="$spacing-inset-xxs"
                height={size}
                {...labelStyle}
              >
                {option.name}
              </Label>
              {option.value === '1' && (
                <Text
                  ff="$mulishBold"
                  fontSize="$font-size-xxxs"
                  color="$text-muted"
                  fontWeight={700}
                >
                  Normal
                </Text>
              )}
            </XStack>
          )
        })}
      </YStack>
      {showInvalidFeedback && (
        <XStack
          gap={5}
          alignItems="center"
          marginTop={15}
          testID="radio-invalid-feedback"
        >
          <HeroIcon
            icon={['fal', 'exclamation-circle']}
            size={12}
            color="$danger-300"
          />
          <Text
            color="$danger-300"
            fontFamily="$mulishRegular"
            fontSize="$font-size-xxxs"
          >
            Este campo é obrigatório! Por favor, selecione uma opção.
          </Text>
        </XStack>
      )}
    </RadioGroup>
  )
}
